// Unified UI Configuration System
// This file contains all positioning and sizing configurations for UI elements

export const UI_CONFIG = {
  // Hero Section Configuration
  hero: {
    airplane: {
      position: {
        top: '10%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 3
      },
      size: {
        maxWidth: '250px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '150px',
          top: '15%'
        },
        '1200px': {
          maxWidth: '120px',
          top: '20%'
        },
        '991px': {
          maxWidth: '100px',
          top: '25%'
        },
        '575px': {
          maxWidth: '80px',
          top: '30%'
        }
      }
    },
    anasBot: {
      position: {
        bottom: '8%',
        left: '8%',
        zIndex: 3
      },
      size: {
        maxWidth: '180px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '150px',
          bottom: '18%',
          left: '4%'
        },
        '1200px': {
          maxWidth: '120px',
          bottom: '16%',
          left: '2%'
        },
        '991px': {
          maxWidth: '90px',
          bottom: '5%',
          left: '-2%'
        },
        '575px': {
          maxWidth: '80px',
          bottom: '5%',
          left: '-5%'
        }
      }
    },
    text: {
      marginLeft: '-100px',
      zIndex: 2,
      titleSpans: {
        second: { paddingLeft: '280px' },
        third: { paddingLeft: '450px' }
      },
      buttons: {
        textAlign: 'right',
        right: '-100px',
        paddingLeft: '120px',
        fontSize: '25px'
      }
    }
  },

  // Features Section Configuration
  features: {
    anasBot: {
      position: {
        bottom: '-50px',
        left: '93.5%',
        transform: 'translateX(-50%)',
        zIndex: 2
      },
      size: {
        maxWidth: '150px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '120px',
          bottom: '-40px',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        '1200px': {
          maxWidth: '100px',
          bottom: '-35px',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        '991px': {
          maxWidth: '80px',
          bottom: '-30px',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        '575px': {
          maxWidth: '60px',
          bottom: '-25px',
          left: '50%',
          transform: 'translateX(-50%)'
        }
      }
    },
    paperPlane: {
      position: {
        top: '20px',
        left: '20px',
        zIndex: 2
      },
      size: {
        maxWidth: '400px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '340px',
          top: '15px',
          left: '15px'
        },
        '1200px': {
          maxWidth: '300px',
          top: '10px',
          left: '10px'
        },
        '991px': {
          maxWidth: '250px',
          top: '8px',
          left: '8px'
        },
        '575px': {
          maxWidth: '200px',
          top: '5px',
          left: '5px'
        }
      }
    }
  },

  // About Section Configuration
  about: {
    girlImage: {
      position: {
        bottom: '-30px',
        right: '20px',
        zIndex: 2
      },
      size: {
        maxWidth: '250px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '200px',
          bottom: '-25px',
          right: '15px'
        },
        '1200px': {
          maxWidth: '180px',
          bottom: '-20px',
          right: '10px'
        },
        '991px': {
          maxWidth: '150px',
          bottom: '-15px',
          right: '5px'
        },
        '575px': {
          maxWidth: '120px',
          bottom: '-10px',
          right: '2px'
        }
      }
    },
    text: {
      textAlign: 'left',
      marginLeft: '0'
    }
  },

  // Services Section Configuration
  services: {
    boyQuestion: {
      position: {
        top: '60%',
        left: '20px',
        transform: 'translateY(-50%)',
        zIndex: 2
      },
      size: {
        maxWidth: '225px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '180px',
          left: '15px'
        },
        '1200px': {
          maxWidth: '150px',
          left: '10px'
        },
        '991px': {
          maxWidth: '120px',
          left: '5px'
        },
        '575px': {
          maxWidth: '100px',
          left: '2px'
        }
      }
    },
    girlBlushing: {
      position: {
        top: '60%',
        right: '20px',
        transform: 'translateY(-50%)',
        zIndex: 2
      },
      size: {
        maxWidth: '225px',
        width: '100%'
      },
      responsive: {
        '1400px': {
          maxWidth: '180px',
          right: '15px'
        },
        '1200px': {
          maxWidth: '150px',
          right: '10px'
        },
        '991px': {
          maxWidth: '120px',
          right: '5px'
        },
        '575px': {
          maxWidth: '100px',
          right: '2px'
        }
      }
    }
  },

  // Global Image Styling
  globalImageStyles: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))'
  },

  // Global Container Styling
  globalContainerStyles: {
    position: 'absolute',
    width: '100%'
  }
};

// Helper function to get responsive values
export const getResponsiveValue = (config, breakpoint) => {
  if (!config.responsive || !config.responsive[breakpoint]) {
    return config;
  }

  return {
    ...config,
    ...config.responsive[breakpoint]
  };
};

// Helper function to generate CSS from config
export const generateCSS = (config, className) => {
  let css = `.${className} {\n`;

  // Add position styles
  if (config.position) {
    Object.entries(config.position).forEach(([key, value]) => {
      css += `  ${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value} !important;\n`;
    });
  }

  // Add size styles
  if (config.size) {
    Object.entries(config.size).forEach(([key, value]) => {
      css += `  ${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value} !important;\n`;
    });
  }

  // Add transform
  if (config.transform) {
    css += `  transform: ${config.transform} !important;\n`;
  }

  css += `}\n\n`;

  // Add responsive styles
  if (config.responsive) {
    Object.entries(config.responsive).forEach(([breakpoint, responsiveConfig]) => {
      css += `@media (max-width: ${breakpoint}) {\n`;
      css += `  .${className} {\n`;

      if (responsiveConfig.position) {
        Object.entries(responsiveConfig.position).forEach(([key, value]) => {
          css += `    ${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value} !important;\n`;
        });
      }

      if (responsiveConfig.size) {
        Object.entries(responsiveConfig.size).forEach(([key, value]) => {
          css += `    ${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value} !important;\n`;
        });
      }

      css += `  }\n`;
      css += `}\n\n`;
    });
  }

  return css;
};

// Export default configuration
export default UI_CONFIG;
